module.exports = __webpack_public_path__ + "static/media/logo.6b31805a.png";